import XHR from 'bpm-xhr';

import { bindEvents } from '../helpers';

class SpotifyController {

	constructor() {
		this.events = bindEvents(this);

		this.CLIENT_ID = '3314d8da488349f5b476753cefefa484';

		if (process.env.NODE_ENV === 'development') {
			this.REDIRECT_URI = 'http://localhost:8080/spotify.html';
		} else {
			this.REDIRECT_URI = 'https://crafted.basicagencydev.com/spotify.html';
		}

		this.authUrl = 'https://accounts.spotify.com/authorize';
		this.api = 'https://api.spotify.com/v1/';
		this.authCode = null;
		this.token = null;
		this.clientToken = null;

		this.scopes = [
			'streaming',
			'user-read-birthdate',
			'user-read-email',
			'user-read-private'
		];

		this.sdk = null;
		this.deviceId = null;

		this.playlistId = null;
		this.playlistIndex = 0;
		this.playlistTracks = null;

		this.audio = null;
		this.audio2 = null;
		this.currentAudio = null;
		this.fadeInInt = null;
		this.fadeOutInt = null;

		this.flags = {
			isAuthorized: false,
			isFirstPlay: false
		};

		this.toggleSections = null;
	}

	start() {
		this.authCode = this.getUrlParameter('code');
		if (this.authCode) window.opener.spotifyCallback(this.authCode);
	}

	prefetch(id) {
		this.toggleSections = document.querySelectorAll('[data-spotify-player]');
		this.playlistId = id;

		this.getAccessToken()
			.then(() => {
				this.getPlaylist(this.clientToken)
					.then((tracks) => {
						this.playlistTracks = tracks;

						if (!this.audio) {
							this.audio = new Audio();
							this.audio2 = new Audio();
							this.currentAudio = this.audio;

							this.audio.addEventListener('ended', this.events._onAudioOneEnded, true);
							this.audio2.addEventListener('ended', this.events._onAudioTwoEnded, true);

							this.audio.addEventListener('timeupdate', this.events._onAudioTimeUpdate);
							this.audio2.addEventListener('timeupdate', this.events._onAudioTimeUpdate);

							this.audio.volume = 0;
							this.audio.loop = false;
							this.audio.src = this.playlistTracks[0]; // eslint-disable-line
						}
					});
			});
	}

	_onAudioOneEnded() {
		this.playlistIndex = ++this.playlistIndex < this.playlistTracks.length ? this.playlistIndex : 0;
		this.currentAudio = this.audio2;
		this.audio2.src = this.playlistTracks[this.playlistIndex];
		this.audio2.play();
		this.fadeInAudio();
	}

	_onAudioTwoEnded() {
		this.playlistIndex = ++this.playlistIndex < this.playlistTracks.length ? this.playlistIndex : 0;
		this.currentAudio = this.audio2;
		this.audio2.src = this.playlistTracks[this.playlistIndex];
		this.audio2.play();
		this.fadeInAudio();
	}

	_onAudioTimeUpdate() {
		if (Math.floor(this.currentAudio.currentTime) === 28) {
			if (this.currentAudio.volume === 1) {
				this.fadeOutAudio();
			}
		}
	}

	// 30 sec preview methods

	playPreviews() {
		this.audio.addEventListener('play', this.events._onAudioPlay);
		this.audio.addEventListener('pause', this.events._onAudioPause);
		this.audio2.addEventListener('play', this.events._onAudioPlay);
		this.audio2.addEventListener('pause', this.events._onAudioPause);

		if (!this.currentAudio.paused) {
			this.currentAudio.pause();
		} else {
			this.currentAudio.play();

			if (!this.flags.isFirstPlay) {
				this.flags.isFirstPlay = true;
				this.fadeInAudio();
			}
		}
	}

	fadeInAudio() {
		let frame = 0;

		this.fadeInInt = setInterval(() => {
			if (frame++ < 100) {
				this.currentAudio.volume = parseFloat(frame * 0.01).toFixed(2);
			} else {
				clearInterval(this.fadeInInt);
			}
		}, 1000 / 100);
	}

	fadeOutAudio() {
		let frame = 0;

		this.fadeOutInt = setInterval(() => {
			if (frame++ < 100) {
				this.currentAudio.volume = 1 - parseFloat(frame * 0.01).toFixed(2);
			} else {
				clearInterval(this.fadeOutInt);
			}
		}, 1000 / 100);
	}

	_onAudioPlay() {
		if (this.toggleSections) {
			this.toggleSections.forEach(section => {
				section.classList.add('is-playing');
				section.classList.add('is-active');

				if (section.classList.contains('sticky-details__player')) {
					section.removeEventListener('click', this.events._onPlay);
					section.addEventListener('click', this.events._onPause);
				}
			});
		}
	}

	_onAudioPause() {
		if (this.toggleSections) {
			this.toggleSections.forEach(section => {
				section.classList.remove('is-playing');

				if (section.classList.contains('sticky-details__player')) {
					section.removeEventListener('click', this.events._onPause);
					section.addEventListener('click', this.events._onPlay);
				}
			});
		}
	}

	_onPlay(e) {
		e.preventDefault();
		this.currentAudio.play();
	}

	_onPause(e) {
		e.preventDefault();
		this.currentAudio.pause();
	}

	// login auth methods

	init(id) {
		this.playlistId = id;

		this.token = sessionStorage.getItem('access_token');

		if (!this.token) {
			this.login();
		} else {
			this.refreshToken().then((token) => {
				this.token = token;
				this.toggleSdk(this.token);
			});
		}
	}

	getLoginUrl() {
		return `${this.authUrl}?client_id=${this.CLIENT_ID}&redirect_uri=${encodeURIComponent(this.REDIRECT_URI)}&scope=${encodeURIComponent(this.scopes.join(' '))}&response_type=code&show_dialog=true`;
	}

	login() {
		let popup = null;

		const loginUrl = this.getLoginUrl();
		const pWidth = 450,
			pHeight = 730,
			pLeft = (window.innerWidth / 2) - (pWidth / 2),
			pTop = (window.innerHeight / 2) - (pHeight / 2);

		popup = window.open(`${loginUrl}`, 'Login with Spotify', `menubar=no,location=no,resizable=no,scrollbars=no,status=no,width=${pWidth},height=${pHeight},left=${pLeft},top=${pTop}`);

		window.spotifyCallback = (code) => {
			if (popup) popup.close();

			this.authorize(code).then((token) => {
				this.token = token;
				this.startPlayer();
			});
		};
	}

	authorize(code) {
		return new Promise((resolve) => {
			const data = new FormData();
			data.append('code', code);
			data.append('redirect_uri', this.REDIRECT_URI);

			new XHR('json')
				.post('/php/spotify-authorize.php', data)
				.then((xhr) => {
					if (xhr.response.access_token) {
						sessionStorage.setItem('access_token', xhr.response.access_token);
						sessionStorage.setItem('access_timestamp', Date.now());
						sessionStorage.setItem('refresh_token', xhr.response.refresh_token);
						resolve(sessionStorage.getItem('access_token'));
					}
				});
		});
	}

	refreshToken() {
		return new Promise((resolve) => {
			const expired = Date.now() - (1000 * 60 * 60); // 60 minutes
			const cached = sessionStorage.getItem('access_timestamp');

			if (cached && cached > expired) {
				resolve(sessionStorage.getItem('access_token'));
			} else {
				const refreshToken = sessionStorage.getItem('refresh_token');
				const data = new FormData();
				data.append('refresh_token', refreshToken);

				new XHR('json')
					.post('/php/spotify-refresh.php', data)
					.then((xhr) => {
						if (xhr.response.access_token) {
							sessionStorage.setItem('access_token', xhr.response.access_token);
							sessionStorage.setItem('access_timestamp', Date.now());
							resolve(sessionStorage.getItem('access_token'));
						}
					});
			}

		});
	}

	// get access token: doesnt require auth
	getAccessToken() {
		return new Promise((resolve) => {
			new XHR('json')
				.post('/php/spotify-client-cred.php')
				.then((xhr) => {
					if (xhr.response.access_token) {
						this.clientToken = xhr.response.access_token;
						// console.log(this.clientToken);
						resolve();
					}
				});
			});
	}

	// api calls

	startPlayer() {
		const toggleSections = document.querySelectorAll('[data-spotify-player]');

		const resume = (e) => {
			e.preventDefault();
			this.sdk.resume();
		};

		const pause = (e) => {
			e.preventDefault();
			this.sdk.pause();
		};

		this.waitForSdkLoad().then((spotify) => {
			const { Player } = spotify;

			this.sdk = new Player({
				name: 'Crafted Web Playback',
				volume: 0.8,
				getOAuthToken: cb => { cb(`${this.token}`); }
			});

			// sdk event listeners

			this.sdk.addListener('player_state_changed', state => {
				if (state.paused) {
					toggleSections.forEach(section => {
						section.classList.remove('is-playing');

						if (section.classList.contains('sticky-details__player')) {
							section.removeEventListener('click', pause);
							section.addEventListener('click', resume);
						}
					});

				} else {
					toggleSections.forEach(section => {
						section.classList.add('is-playing');
						section.classList.add('is-active');

						if (section.classList.contains('sticky-details__player')) {
							section.removeEventListener('click', resume);
							section.addEventListener('click', pause);
						}
					});
				}
			});

			this.sdk.addListener('ready', ({ device_id }) => { // eslint-disable-line
				this.deviceId = device_id; // eslint-disable-line
				this.getPlaylist(this.token).then(tracks => this.playTracks(this.token, this.deviceId, tracks));
			});

			this.sdk.connect();
		});
	}

	destroyPlayer() {
		if (this.audio || this.audio2) {
			this.destroyAudio(this.audio);
			this.destroyAudio(this.audio2);
			this.audio = null;
			this.audio2 = null;
			this.currentAudio = null;
			this.playlistTracks = null;
			this.playlistIndex = 0;
		}

		if (this.toggleSections) {
			this.toggleSections.forEach(section => {
				section.classList.remove('is-active');
				section.classList.remove('is-playing');

				if (section.classList.contains('sticky-details__player')) {
					section.removeEventListener('click', this.events._onPlay);
					section.removeEventListener('click', this.events._onPause);
				}
			});

			this.toggleSections = null;
		}

		if (this.sdk) {
			const toggleSections = document.querySelectorAll('[data-spotify-player]');

			toggleSections.forEach(section => {
				section.classList.remove('is-playing');
				section.classList.remove('is-active');
			});

			this.sdk.removeListener('player_state_changed');
			this.sdk.removeListener('ready');
			this.sdk.disconnect();
			this.sdk = null;
		}

		this.flags.isFirstPlay = false;
	}

	destroyAudio(audio) {
		audio.pause();
		audio.currentTime = 0;
		audio.removeEventListener('play', this.events._onAudioPlay);
		audio.removeEventListener('pause', this.events._onAudioPause);
		audio.removeEventListener('ended', this.events._onAudioOneEnded);
		audio.removeEventListener('ended', this.events._onAudioTwoEnded);
		audio.removeEventListener('timeupdate', this.events._onAudioTimeUpdate);
	}

	getPlaylist(token) {
		return new Promise((resolve) => {
			const tracks = [];

			new XHR('json')
				.setHeader('Authorization', `Bearer ${token}`)
				.setHeader('Content-Type', 'application/json')
				.get(`${this.api}playlists/${this.playlistId}/tracks`)
				.then((xhr) => {
					if (xhr.response) {
						// if (type === 'full') {
						// 	xhr.response.items.forEach(item => tracks.push(item.track.uri));
						// } else if (type === 'preview') {
						// 	xhr.response.items.forEach(item => tracks.push(item.track.preview_url));
						// }
						xhr.response.items.forEach(item => {
							if (item.track.preview_url) {
								tracks.push(item.track.preview_url);
							}
						});
						resolve(tracks);
					} else {
						// console.error('Could not get tracks');
					}
				});
		});
	}

	playTracks(token, id, tracks) {
		new XHR('json')
			.setHeader('Authorization', `Bearer ${token}`)
			.setHeader('Content-Type', 'application/json')
			.put(
				`${this.api}me/player/play?device_id=${id}`,
				`{"uris": ${JSON.stringify(tracks)}}`
			);
	}

	// sdk player methods

	toggleSdk(token) {
		if (this.sdk) {
			this.sdk.togglePlay();
		} else {
			this.startPlayer(token);
		}
	}

	waitForSdkLoad() {
		return new Promise(resolve => {
			if (window.Spotify) {
				resolve(window.Spotify);
			} else {
				window.onSpotifyWebPlaybackSDKReady = () => resolve(window.Spotify);
			}
		});
	}

	// utils

	getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); // eslint-disable-line
		const regex = new RegExp('[\\?&]' + name + '=([^&#]*)'); // eslint-disable-line
		const results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

}

export default new SpotifyController();
